import { render, staticRenderFns } from "./DataCoverageSettings.vue?vue&type=template&id=115d7864"
import script from "./DataCoverageSettings.vue?vue&type=script&lang=js"
export * from "./DataCoverageSettings.vue?vue&type=script&lang=js"
import style0 from "./DataCoverageSettings.vue?vue&type=style&index=0&id=115d7864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports